<template>
  <div v-if="errorStore.nextFatalError" class="error-page">
    <h1 class="error-title">Oups ! ({{ errorStore.nextFatalError.name }})</h1>
    <div class="error-message">{{ errorStore.nextFatalError.message }}</div>
  </div>
</template>

<script lang="ts" setup>
import useErrorsStore from '@/stores/errorStore.ts';

const errorStore = useErrorsStore();
</script>

<style scoped lang="scss">
.error-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .error-title {
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .error-message {
    font-size: 1.1em;
  }
}
</style>
